jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();

  //Subnav stuff
  //Hide subnav if less than one item
  if ($('.subnav ul li').length < 1) {
    $('.subnav').remove();
  }

  if ($('.subnav ul li.active').length) {
    $('.subnav').addClass('active');
  }

  //Replace subnav h2 with page title
  // if ($(".subnav h2").length) {
  //   $(".subnav h2").text($('.title h1').text() + ':');
  // }
  //End Subnav stuff

  //View More for Banking Solution List
  $('.banking-solution-item .read-more').click(function () {
    var $more = $(this).closest('.banking-solution-item');
    var $toggletext = $(this).closest('.banking-solution-item .read-more');

    if ($more.hasClass('expanded')) {
      $more.removeClass('expanded');
      $toggletext.text("Read More");
    } else {
      $more.addClass('expanded');
      $toggletext.text("Show Less");
    }
  });

  $('.banking-solution-item .read-more').on('keypress', function (e) {
    if (e.which === 13) {
      var $more = $(this).closest('.banking-solution-item');
      var $toggletext = $(this).closest('.banking-solution-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.text("Read More");
      } else {
        $more.addClass('expanded');
        $toggletext.text("Show Less");
      }
    }
  });

  //If a Fullwidth Image Section is on a page with a sidebar, move it below the container.
  $('body.subpage.sidebar .main-content .image-section-fullwidth').each(function () {
    $(this).insertAfter($(this).parent().parent().parent());
  });

  //Tabs for mobile
  if ($('.tabs').length) {
    $('.tabs .tab-con').prepend('<div class="tab-toggle"></div>');
    $('.tab-toggle').click(function () {
      $(this).next('.tab-list').toggleClass('open');
      $('.tab-list a').click(function () {
        $('.tab-list.open').removeClass('open');
      });
    });
  }

  //Add Location number / Remove if empty
  $('.location-information span[itemprop="telephone"] a').each(function () {
    var text = $(this).text();
    $(this).attr('href', 'tel:1' + text);
    if ($(this).is(':empty')) {
      $(this).parent().remove();
    }
  });

  //Remove description
  $('.location-description').each(function () {
    if (!$(this).text().trim().length) {
      $(this).remove();
    }
  });

  //Subpage banner functionality
  if ($('.banner-wrapper img').length) {
    $('.banner-wrapper').addClass('image');
  } else {
    $('.banner-wrapper').addClass('no-image');
  }

});